import React from 'react';
import './SearchFilterControls.css';

const SearchFilterControls = ({ 
  activeTab, 
  searchQuery, 
  setSearchQuery, 
  selectedIndustry, 
  setSelectedIndustry, 
  proofT 
}) => {
  return (
    <div className="view-options">
      <input
        type="text"
        placeholder={
          activeTab === 'integrations' ? proofT('search.integrations') :
          activeTab === 'partnerships' ? proofT('search.partners') :
          activeTab === 'tech-stack' ? proofT('search.technologies') :
          proofT('search.caseStudies')
        }
        className="search-input"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <select 
        className="filter-select" 
        value={selectedIndustry}
        onChange={(e) => setSelectedIndustry(e.target.value)}
      >
        <option value="all">{proofT('filters.allIndustries')}</option>
        {activeTab === 'integrations' ? (
          <>
            <option value="medical">{proofT('filters.industries.medical')}</option>
            <option value="restaurant">{proofT('filters.industries.restaurant')}</option>
            <option value="business">{proofT('filters.industries.business')}</option>
            <option value="beauty">{proofT('filters.industries.beauty')}</option>
            <option value="hotel">{proofT('filters.industries.hotel')}</option>
            <option value="event">{proofT('filters.industries.event')}</option>
          </>
        ) : (
          <>
            <option value="healthcare">{proofT('filters.industries.healthcare')}</option>
            <option value="finance">{proofT('filters.industries.finance')}</option>
            <option value="retail">{proofT('filters.industries.retail')}</option>
            <option value="education">{proofT('filters.industries.education')}</option>
            <option value="technology">{proofT('filters.industries.technology')}</option>
            <option value="manufacturing">{proofT('filters.industries.manufacturing')}</option>
          </>
        )}
      </select>
    </div>
  );
};

export default SearchFilterControls;






